<template>
  <section>
    <slot name="header-content"></slot>
    <b-table
      :items="items"
      :fields="fields"
      responsive="sm"
      show-empty
      head-variant="light"
      :class="classTable"
      :busy="loading"
      class="main-table"
      empty-text="No hay datos para mostrar"
    >
      <template v-slot:cell()="data">
        <slot :labelKey="data.field.key" :value="data.value" name="rowCell">
          {{
          data.value
          }}
        </slot>
      </template>
      <template v-slot:cell(actions)="row">
        <div class="table-actions">
          <b-button
            v-for="action in actions"
            :key="action.name"
            variant="link"
            size="sm"
            @click="info(row.item, action.name, action.modal)"
          >
            <i class="fa-lg" :class="action.icon"></i>
          </b-button>
        </div>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Cargando...</strong>
        </div>
      </template>
      <template v-if="!loading" v-slot:empty="scope" class="table-empty text-center">
        <h4 class="text-center">{{ scope.emptyText }}</h4>
        <i class="fas fa-box-open"></i>
      </template>
    </b-table>
    <div class="table-footer">
      <b-row class="m-0">
        <b-col>
          <slot name="table-footer"></slot>
        </b-col>
        <b-col>
          <b-pagination
            v-if="items.length !== 0 && search.length === 0"
            v-model="page"
            :total-rows="rows"
            :per-page="pageSize"
            first-text="Inicio"
            last-text="Fin"
            align="right"
            pills
            class="table-pagination"
            @change="changePage"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    },
    classTable: {
      type: String,
      default: "data-table"
    },
    loading: {
      type: Boolean,
      default: false
    },
    pageNum: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number
    },
    rows: {
      type: Number,
      default: 6
    },
    search: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      page: this.pageNum
    };
  },
  methods: {
    info(item, action, modal) {
      this.$emit(action, { item, id: modal });
    },
    changePage(numPage) {
      this.$emit("changePage", numPage);
    }
  }
};
</script>

<style lang="scss">
.table-pagination {
  margin-right: 1rem;
}
.table-footer {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
}
.main-table {
  min-height: 400px;
  position: relative;
  font-size: 1rem;
}
.b-table-empty-row td,
.b-table-busy-slot td {
  display: flex;
  border: 0px;
  text-align: center;
  width: 100%;
  align-items: center;
  position: absolute;
  height: 100%;
  justify-content: center;
  & i {
    margin-top: 1rem;
    font-size: 2.5rem;
  }
}

.table-actions {
  text-align: center;
  display: flex;
  justify-content: space-evenly;
}
</style>
